import React from "react";

const APART_IMG =
    "https://static.prod-images.emergentagent.com/jobs/81057d82-68a6-4ab2-8cb6-656337b4e5ea/images/8ad96ff86703867e1e5da3809d721b11c6aee249a19bad4786a8176b0382d342.png";

const pillars = [
    {
        n: "01",
        title: "Live event experience",
        body: "Hands-on work in site management, install, prop handling and de-rig informs every visual.",
    },
    {
        n: "02",
        title: "Production-aware design",
        body: "Visuals are considered, practical and grounded in how temporary spaces come together on site.",
    },
    {
        n: "03",
        title: "Bridging ambition & delivery",
        body: "Closing the gap between creative concept and what suppliers can actually build.",
    },
];

export default function SetsApart() {
    return (
        <section
            id="sets-apart"
            data-testid="sets-apart-section"
            className="section-pad"
        >
            <div className="container-edge">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
                    <div className="md:col-span-5 md:sticky md:top-28">
                        <h2
                            data-testid="sets-apart-heading"
                            className="font-display text-4xl md:text-5xl lg:text-[56px] tracking-tight font-medium leading-[1.04] text-balance"
                        >
                            Visualisation with{" "}
                            <span className="italic font-normal text-champagne">
                                production knowledge.
                            </span>
                        </h2>
                        <p className="mt-8 text-foreground/75 text-[15px] leading-relaxed max-w-md">
                            This is not visualisation created in isolation from how
                            events are actually built. The work is shaped by hands-on
                            experience in live events, technical planning, supplier
                            coordination and real-world production pressures.
                        </p>
                    </div>

                    <div className="md:col-span-7">
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                                src={APART_IMG}
                                alt="On-site production environment"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-foreground/85 to-transparent">
                                <p className="overline !text-background/80">
                                    Rough idea ↔ Presentation-ready
                                </p>
                                <p className="mt-2 text-background text-sm max-w-md">
                                    Visuals built with what actually happens on
                                    site in mind — access, scale, install windows,
                                    crew movement, materials and de-rig.
                                </p>
                            </div>
                        </div>

                        <div className="mt-px grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
                            {pillars.map((p) => (
                                <div
                                    key={p.n}
                                    className="bg-background p-6 md:p-8"
                                >
                                    <h3 className="font-display text-xl font-medium tracking-tight">
                                        {p.title}
                                    </h3>
                                    <p className="mt-2 text-foreground/70 text-[13.5px] leading-relaxed">
                                        {p.body}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
